// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dropdown-link[data-v-6a491685]{\n  margin-left: 10px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
